import { Icon, withStyles } from '@material-ui/core';
import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Box } from 'react-layout-components';
import FadeFromDown from '../transitions/FadeFromDown';

class ScrollDownFab extends React.PureComponent {

    state = {
        visible: false
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({
                visible: true
            })
        }, 1800)
    }

    render() {

        const { classes } = this.props
        return (
            <FadeFromDown visible={this.state.visible}>
                <Box className={classes.root} center column>
                    <Icon className={cn(classes.icon, 'animate-infinity-down')}>expand_more</Icon>
                    <Icon className={cn(classes.icon, 'animate-infinity-down animate-infinity-down-two')}>expand_more</Icon>
                </Box>
            </FadeFromDown>
        )
    }

}

ScrollDownFab.propTypes = {
    classes: PropTypes.any
}

const styles = theme => ({
    root: {
        position: 'relative',
        width: 64,
        height: 64,
        color: theme.palette.primary.main
    },
    icon: {
        position: 'absolute',
        transform: [{ translateX: '-50%' }, { translateY: '-50%' }]
    }
})

export default withStyles(styles)(ScrollDownFab)


// WEBPACK FOOTER //
// ./src/components/common/ScrollDownFab.js